import styled from "@emotion/styled"
import React from "react"
import Helmet from "react-helmet"

import config from "../../config/site-config"
import Default from "../components/Layouts/Default"
import SEO from "../components/SEO/SEO"
import { ContentLimit, GridBase } from "../helpers/grid"
import { colorScheme } from "../helpers/styleSettings"

const Career = (): JSX.Element => {
  return (
    <Default>
      <CareerWrap>
        <SEO />
        <Helmet>
          <title>{`The team | ${config.siteName}`}</title>
          <link rel="canonical" href={`${config.siteUrl}/team/`} />
        </Helmet>
        <TeamContent>
          <h3>Team</h3>
          <p>
            Meet the heart and soul of A Bit Ago Studio!
          </p>
          <p>
            We're a cozy crew of creative minds, geeking out over code, art, and storytelling. 
            Here, every idea is worth a game level, and every coffee break sparks a new adventure. 
            Our small but mighty team packs a punch in imagination and spirit, making sure that fun 
            is at the core of everything we do. Can't wait to introduce you to our band of game magicians — <b>stay tuned!</b>
          </p>
          <p>
            More here soon...
          </p>
        </TeamContent>
      </CareerWrap>
    </Default>
  )
}

const CareerWrap = styled.div`
  ${GridBase};
  padding-top: 60px;
`

const TeamContent = styled.div`
  z-index: 501;
  position: relative;
  height: 100%;
  min-height: calc(100vh - 60px);
  /* padding-bottom: 4em; */
  padding: 0 1em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${colorScheme.text};
  ${ContentLimit};

  > div {
    max-width: 70ch;
    @media (min-width: 1024px) {
      max-width: 220ch;
    }
  }

  h1 {
    color: ${colorScheme.support};
    font-size: 2em;
    font-weight: 900;
    margin: 0;
    @media (min-width: 768px) {
      font-size: 3em;
    }
    @media (min-width: 1024px) {
      font-size: 5em;
    }
  }

  h2 {
    font-size: 1.75em;
    margin: 0;
    @media (min-width: 768px) {
      font-size: 2.25em;
    }
    @media (min-width: 1024px) {
      font-size: 4em;
    }
  }

  p {
    line-height: 1.55;
    font-size: 1.125em;
    @media (min-width: 768px) {
      font-size: 1.25em;
    }
    @media (min-width: 768px) {
      font-size: 1.45em;
      line-height: 1.25;
    }
  }

  a {
    color: ${colorScheme.supportPink};
    text-decoration: 3px solid underline;
    webkit-text-decoration: 3px solid solid underline;
    -webkit-text-underline-position: auto;
    text-underline-position: auto;
    &:hover {
      text-decoration: none;
    }
  }
`
export default Career
